import { CommanderThunkAction } from '@mews-commander/types';

export function reportError(message: string): CommanderThunkAction {
    return (dispatch, getState, { loggerService }) => {
        // @ts-expect-error
        loggerService.log(message);
    };
}
